var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition-group",
        { attrs: { name: "fade", tag: "div" } },
        _vm._l([_vm.currentNumber], function(number) {
          return _c("div", { key: number }, [
            _c("a", { staticClass: "block", attrs: { href: _vm.currentUrl } }, [
              _c("img", {
                attrs: { src: _vm.currentImage },
                on: { mouseover: _vm.stopRotation, mouseout: _vm.startRotation }
              })
            ])
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }